import { useRouter } from 'vue-router'
import { useJwtStore } from '@/stores'
import { persistFreeK8sIntent } from '@/composables/useOnboardingIntent'

/**
 * Free-tier Kubernetes claim flow, shared by the landing-page hero CTA,
 * the sticky mobile CTA and the free-tier pricing card.
 *
 *  - Logged-out users go to /register?intent=free-k8s. The register flow
 *    detects the intent param and, after successful registration + phone
 *    verification, automatically calls POST /k8s/free/claim.
 *  - Logged-in users go straight to the K8s dashboard claim modal at
 *    /dashboard/services/kubernetes?action=claim-free (Phase 1c task 30).
 *
 * HomeHero.vue intentionally links via a plain `:to` (hardcoded query)
 * instead of this composable so the CTA stays an SSR-crawlable anchor.
 */
export function useFreeK8sClaim() {
  const router = useRouter()
  const jwtStore = useJwtStore()

  function claimFreeTier() {
    if (jwtStore.getJwt) {
      // Limited = email not verified yet: the claim cannot succeed until
      // verification, so persist the intent — the verify-email landing page
      // resumes the claim flow from it.
      const content = jwtStore.getJwtContent
      if (content?.limited === true) {
        persistFreeK8sIntent(content.id)
      }
      void router.push({
        name: 'dashboardKubernetes',
        query: { action: 'claim-free' }
      })
    } else {
      void router.push({ name: 'register', query: { intent: 'free-k8s' } })
    }
  }

  return { claimFreeTier }
}
